import { Fragment, useState } from 'react'; 
import { isDesktop } from 'react-device-detect';
import PropTypes from 'prop-types';
import axios from 'axios';

import { urlForm } from '../../Constants'; 

//components
import LateralIzquierdo from '../../ads/LateralIzquierdo';
import LateralDerecho from '../../ads/LateralDerecho';
import Caja3 from '../../ads/Caja3';
import Zocalo  from '../../ads/Zocalo'; 
import Footer from '../common/Footer';
import AddForm from './AddForm'
import ConfirmationModal from './ConfirmationModal';

const Form = props => {

    const { idPostal } = props;
    const [isSubmittedToGoogleForm, setIsSubmittedToGoogleForm] = useState(false);
    const [idTarjeta, setidTarjeta] = useState(0);

    const onSubmit = async data => {
        console.log('OK!')                
        const responseOk = 200;
        const id = Date.now();        
        const { name, msg } = data;
        
        const formData = new FormData();        
        formData.append('entry.140135586', id);        
        formData.append('entry.1209914977', idPostal);       
        formData.append('entry.178666121', name);
        formData.append('entry.359529864', msg.trim());        

        try {
            const response = await axios.post(urlForm, formData);
            if(response.status === responseOk){ 
                setIsSubmittedToGoogleForm(true);
                setidTarjeta(id);
            } 
        } catch (error) {
            setIsSubmittedToGoogleForm(true);
            setidTarjeta(id);
        }   

        return isSubmittedToGoogleForm;
    }

    return (
        <Fragment>
            <main className="container cont-principal px-0 cont-layout">
                <section className="d-flex justify-content-around">
                    {isDesktop && <LateralIzquierdo />}
                    <section className="container my-3 mt-md-4 mb-md-5 px-4 px-md-0">
                        { 
                            !isSubmittedToGoogleForm 
                                ? <AddForm onSubmit={onSubmit} idPostal={idPostal} /> 
                                : <ConfirmationModal idTarjeta={idTarjeta} />
                        }
                    </section>
                    {isDesktop && <LateralDerecho />}    
                </section>                                        
                <section className="content-msgs">
                    {!isDesktop && <Caja3 />}        
                    <Zocalo isDesktop={isDesktop} />
                </section> 
            </main>
            <Footer />
        </Fragment>      
    )   
}

export default Form;

Form.propTypes = {
    idPostal: PropTypes.string.isRequired,
}
